import type { Project, User, PrintResult } from "./types";

const BASE = "/api";

async function fetchJSON<T>(url: string, options?: RequestInit): Promise<T> {
	const res = await fetch(url, options);
	if (!res.ok) throw new Error(`API error: ${res.status}`);
	return res.json();
}

export const api = {
	projects: {
		list(sort?: string, material?: string, search?: string) {
			const params = new URLSearchParams();
			if (sort) params.set("sort", sort);
			if (material) params.set("material", material);
			if (search) params.set("search", search);
			return fetchJSON<Project[]>(`${BASE}/projects?${params}`);
		},
		get(id: string) {
			return fetchJSON<Project>(`${BASE}/projects/${id}`);
		},
		create(data: {
			title: string;
			description: string;
			creatorId: string;
			stlFileName: string;
			stlFileSize: number;
			printSettings: Project["printSettings"];
			tags: string[];
		}) {
			return fetchJSON<Project>(`${BASE}/projects`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(data),
			});
		},
		fork(id: string, userId: string, settings?: Partial<Project["printSettings"]>) {
			return fetchJSON<Project>(`${BASE}/projects/${id}/fork`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ userId, settings }),
			});
		},
		addResult(id: string, data: { userId: string; rating: number; comment: string; photoUrls: string[] }) {
			return fetchJSON<PrintResult>(`${BASE}/projects/${id}/results`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(data),
			});
		},
	},
	users: {
		list() {
			return fetchJSON<User[]>(`${BASE}/users`);
		},
		get(id: string) {
			return fetchJSON<User>(`${BASE}/users/${id}`);
		},
	},
	leaderboard() {
		return fetchJSON<User[]>(`${BASE}/leaderboard`);
	},
	upload(file: File) {
		const form = new FormData();
		form.append("file", file);
		return fetchJSON<{ id: string; name: string; size: number; url: string }>(`${BASE}/upload`, {
			method: "POST",
			body: form,
		});
	},
};
